import { Injectable } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogComponent } from './confirmation-dialog.component';

@Injectable()
export class ConfirmationDialogService {
  isIdle = false;
  isSkip=false;
  private modalRef: NgbModalRef | undefined;
  constructor(private modalService: NgbModal,) {
  }

  public confirm(
    title: string,
    message: string,
    btnOkText: string = 'OK',
    btnCancelText: string = 'Cancel',
    isButtonShow: boolean = true,
    closeTime: number = 0,
    dialogSize: 'sm' | 'lg' = 'sm'): Promise<boolean> {
    this.modalRef = this.modalService.open(ConfirmationDialogComponent, { size: dialogSize, backdrop: 'static', keyboard: false, windowClass: "modal-md" });
    this.modalRef.componentInstance.title = title;
    this.modalRef.componentInstance.message = message;
    this.modalRef.componentInstance.btnOkText = btnOkText;
    this.modalRef.componentInstance.btnCancelText = btnCancelText;
    this.modalRef.componentInstance.isButtonShow = isButtonShow;
    this.modalRef.componentInstance.closeTime = closeTime;
    return this.modalRef.result;
  }
  public closeConfirmationDialog(): void {
    if (this.modalRef) {
      this.modalRef.close();
    }
  }
}
